export const getMotives = `query motives($query: MotiveQueryInput, $limit: Int, $sortBy: MotiveSortByInput){
  motives(query: $query, limit: $limit, sortBy: $sortBy) {
      _id
      value
      label
    }
  }` 